import { combineReducers } from 'redux';

import { initializable } from '../../utils/editor';
import { EDITOR_NAME } from '../connect-editor';
import campaign from './campaign';
import campaignLineCreativesByLineId from './campaign-line-creatives-by-line-id';
import campaignLineFilters from './campaign-line-filters';
import campaignLinesById from './campaign-lines-by-id';
import campaignUI from './campaign-ui';
import savedCampaign from './saved-campaign';

export default initializable(
  EDITOR_NAME,
  combineReducers({
    campaign,
    campaignLinesById,
    campaignLineCreativesByLineId,
    campaignLineFilters,
    campaignUI,
    savedCampaign,
  }),
);
